import React from "react";
import { useLocation, Link } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const routeConfig = {
    "/gallery": {
      title: "Gallery",
      image_page: "gallery",
      breadcrumbs: ["Home", "Gallery"],
    },
    "/about": {
      title: "About Us",
      image_page: "about",
      breadcrumbs: ["Home", "Pages", "About"],
    },
    "/services": {
      title: "Our Services",
      image_page: "services",
      breadcrumbs: ["Home", "Pages", "Services"],
    },
    "/contact": {
      title: "Contact Us",
      image_page: "contact",
      breadcrumbs: ["Home", "Pages", "Contact"],
    },
    "/our-team": {
      title: "Our Team",
      breadcrumbs: ["Home", "Our Team"],
    },
    "/courses": {
      title: "Courses",
      image_page: "courses",
      breadcrumbs: ["Home", "Courses"],
    },
    "/register": {
      title: "Register",
      image_page: "register",
      breadcrumbs: ["Home", "Register"],
    },
    // "/blogger": {
    //   title: "Blogger",

    //   breadcrumbs: ["Home", "Blogger"],
    // },
    // Default configuration
    default: {
      title: "",
      breadcrumbs: [],
    },
  };

  // Get current route configuration
  const currentRoute = routeConfig[location.pathname] || routeConfig.default;

  return (<>
    {currentRoute.title && ( // Show header only if a title is defined for the route
      (<div className={`container-fluid bg-primary py-5 mb-5 page-header ${currentRoute.image_page}`}>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                {currentRoute.title}
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  {currentRoute.breadcrumbs.map((crumb, index) => (
                    <li
                      key={index}
                      className={`breadcrumb-item ${
                        index === currentRoute.breadcrumbs.length - 1
                          ? "text-white active"
                          : ""
                      }`}
                      aria-current={
                        index === currentRoute.breadcrumbs.length - 1
                          ? "page"
                          : undefined
                      }
                    >
                      {index !== currentRoute.breadcrumbs.length - 1 ? (
                        <Link className="text-white" to="/">
                          {crumb}
                        </Link>
                      ) : (
                        crumb
                      )}
                    </li>
                  ))}
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>)
    )}
  </>);
};
export default Header;